import { useMemo } from 'react';
var converter = require("number-to-words");

const convertToIndianFormat = (num) => {
  if (num < 100000) {
    return converter.toWords(num);
  }

  const crore = Math.floor(num / 10000000);
  const lakh = Math.floor((num % 10000000) / 100000);
  const thousand = Math.floor((num % 100000) / 1000);
  const hundred = Math.floor((num % 1000) / 100);
  const remainder = num % 100;

  let words = [];

  if (crore > 0) words.push(`${converter.toWords(crore)} crore`);
  if (lakh > 0) words.push(`${converter.toWords(lakh)} lakh`);
  if (thousand > 0) words.push(`${converter.toWords(thousand)} thousand`);
  if (hundred > 0) words.push(`${converter.toWords(hundred)} hundred`);
  if (remainder > 0) words.push(converter.toWords(remainder));

  return words.join(", ");
};

const useAmountToWords = (amt) => {
  return useMemo(() => {
    const total = amt;

    if (isNaN(total)) {
      return ""; // or any appropriate handling if total is not a number
    }

    const totalAmount = Number(total) || 0;
    const integerPart = Math.floor(totalAmount);
    const decimalPart = Math.round((totalAmount - integerPart) * 100);

    const integerWords = convertToIndianFormat(integerPart);
    const decimalWords = converter.toWords(decimalPart);

    let result = `INR ${integerWords} rupees`;
    if (decimalPart > 0) {
      result += ` and ${decimalWords} paisa`;
    }

    return result.toUpperCase();
  }, [amt]);
};

export default useAmountToWords;




// import { useMemo } from 'react';
// var converter = require("number-to-words");

// const useAmountToWords = (amt) => {
//   return useMemo(() => {
//     const total = amt;

//     if (isNaN(total)) {
//       return ""; // or any appropriate handling if total is not a number
//     }

//     const totalAmount = Number(total) || 0;

//     const integerPart = Math.floor(totalAmount);
//     const decimalPart = Math.round((totalAmount - integerPart) * 100);

//     const integerWords = converter.toWords(integerPart);
//     const decimalWords = converter.toWords(decimalPart);

//     let result = `INR ${integerWords} rupees`;
//     if (decimalPart > 0) {
//       result += ` and ${decimalWords} paisa`;
//     }

//     return result?.toUpperCase();
//   }, [amt]);
// };

// export default useAmountToWords;
